declare global {
  interface Window {
    __CONFIG__?: {
      API_URL?: string;
    };
  }
}

export const API_URL = window.__CONFIG__?.API_URL || process.env.REACT_APP_API_URL || '';
